import { Directive, ElementRef, HostBinding, Input } from '@angular/core';
import { mixinDisabled } from '../core/common';
import type { CanDisable } from '../core/common/disabled';

// Boilerplate for applying mixins to MatTabLabelWrapper.
const _MatTabLabelWrapperMixinBase = mixinDisabled(class {});

/**
 * Used in the `mat-tab-group` view to display tab labels.
 */
@Directive({
  selector: '[appMatTabLabelWrapper]',
})
export class MatTabLabelWrapperDirective extends _MatTabLabelWrapperMixinBase implements CanDisable {
  @HostBinding('class.mat-tab-disabled')
  @HostBinding('attr.aria-disabled')
  @Input()
  override disabled = super.disabled;

  constructor(public elementRef: ElementRef) {
    super();
  }

  /** Sets focus on the wrapper element */
  focus(): void {
    this.elementRef.nativeElement.focus();
  }

  getOffsetLeft(): number {
    return this.elementRef.nativeElement.offsetLeft;
  }

  getOffsetWidth(): number {
    return this.elementRef.nativeElement.offsetWidth;
  }
}
